export default interface User {
	id: number
	token: string
}

const guest: User = { id: 0, token: "" }

export { guest }